const handleToggle = (wrap) => {
  const hiddenClass = 'is-hidden';
  const activeClass = 'toggle-is-active';

  const action: HTMLElement = wrap.querySelector('[data-toggle-action]');
  const closedLabel = action?.dataset?.closedlabel;
  const openLabel = action?.dataset?.openlabel;

  const hidable = wrap.querySelectorAll('[data-toggle-target]');

  if (hidable.length <= 0 || !action) {
    return;
  }

  const actionLabel: HTMLElement = action.querySelector('.button__label');

  const toggle = () => {
    hidable.forEach((elm) => {
      if (elm.classList.contains(hiddenClass)) {
        elm.classList.remove(hiddenClass);
        actionLabel.innerText = openLabel || 'Close';
        wrap.classList.add(activeClass);
        action.classList.add(activeClass);
      } else {
        elm.classList.add(hiddenClass);
        actionLabel.innerText = closedLabel || 'Show more';
        wrap.classList.remove(activeClass);
        action.classList.remove(activeClass);
      }
    });
  };
  action.addEventListener('click', (evt) => {
    evt.preventDefault();
    toggle();
  });
  wrap.addEventListener('toggle', () => toggle());
};
(function () {
  const items: NodeListOf<HTMLElement> = document.querySelectorAll('[data-toggle]');
  items.forEach((wrap) => handleToggle(wrap));
})();
